// extracted by mini-css-extract-plugin
export default {"fade":"LoginLanding_fade__MS+QX","modal-backdrop":"LoginLanding_modal-backdrop__2YxYf","show":"LoginLanding_show__NTOoy","LoginLanding":"LoginLanding_LoginLanding__9zH8W"};